// export enum TicketStatus {
//     EventDay,
//     Inactive,
//     Active,
//     None
// }

export enum TicketStatus {
    Registered = 'Registered',
    Activated = 'Activated',
    OnEvent = 'OnEvent',
    None = 'none'
}


// WEBPACK FOOTER //
// ./src/pages/event-ticket/event-ticket-status.ts